module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels2_BW-p-800-abec05fd74d08a5a53ecbb3a3d6619ea.jpg";